export default {
      id: "pause-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#pause",
      toString: function () {
        return this.url;
      }
    }